/* 
 - TODO: Explanation
*/

import { DatabaseTable, returnID } from "../BaseTable";
import { types } from "../../helpers/Util";

class InteractionNodeIntervalRaw extends DatabaseTable {
  id: number;
  interaction_node_id: number;
  interval_id: number;
  condition_id: number | null;
  communication_set_id: number | null;
  target: string;
  modified: Date;

  static readonly serializableFields = new Map([
    ["id", [types.number]],
    ["interaction_node_id", [types.number]],
    ["interval_id", [types.number]],
    ["condition_id", [types.number, types.null]],
    ["communication_set_id", [types.number, types.null]],
    ["target", [types.string]],
    ["modified", [types.date, types.string]],
  ]);
  static readonly tableName = "InteractionNodeInterval";

  constructor(
    id = -1,
    interaction_node_id = -1,
    interval_id = -1,
    condition_id = null,
    communication_set_id = null,
    target = "",
    modified = new Date(),
  ) {
    super();
    this.id = returnID(id);
    this.interaction_node_id = interaction_node_id;
    this.interval_id = interval_id;
    this.condition_id = condition_id;
    this.communication_set_id = communication_set_id;
    this.target = target;
    this.modified = modified;
  }
}

class InteractionNodeInterval extends InteractionNodeIntervalRaw {
  constructor(...args: any[]) {
    super(...args);
  }
}

export default InteractionNodeInterval;
